import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { AlertTriangleIcon, TrendingDownIcon, UserXIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const problems = [{
    icon: TrendingDownIcon,
    title: 'Sarcopenia Silenciosa',
    description: 'Perdés entre 3-8% de masa muscular por década después de los 30. Es invisible hasta que ya no podés levantar a tus nietos.'
  }, {
    icon: UserXIcon,
    title: 'Dependencia Inevitable',
    description: 'Cada año sin entrenar fuerza es un paso más cerca de necesitar ayuda para tareas básicas. La fragilidad no avisa.'
  }, {
    icon: AlertTriangleIcon,
    title: 'El Mito del Cardio',
    description: 'Caminar 10.000 pasos no frena la pérdida muscular. Tu cuerpo necesita tensión estructural, no solo movimiento.'
  }];
  return <section ref={ref} className="w-full bg-bg-secondary py-20 px-4 sm:px-6 lg:px-8" data-id="element-138">
      <div className="max-w-6xl mx-auto" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-140">
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-text-primary mb-6" data-id="element-141">
            Tu cuerpo está bajo <span className="text-red-500" data-id="element-142">ataque</span>
          </h2>
          <p className="text-xl sm:text-2xl text-text-secondary max-w-3xl mx-auto font-body leading-relaxed" data-id="element-143">
            Hay una diferencia cruel entre vivir muchos años y estar vivo hasta
            el último día. En Argentina, nos enseñaron que envejecer es sinónimo
            de fragilidad.{' '}
            <span className="text-accent-bronze font-semibold" data-id="element-144">
              Te mintieron.
            </span>
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-145">
          {problems.map((problem, index) => {
          const Icon = problem.icon;
          return <motion.div key={problem.title} initial={{
            opacity: 0,
            y: 30
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-bg-tertiary border border-red-900/30 rounded-sm p-8 hover:border-red-700/50 transition-colors duration-300" data-id="element-146">
                <div className="flex items-start gap-4" data-id="element-147">
                  <div className="flex-shrink-0 w-12 h-12 bg-red-900/20 rounded-sm flex items-center justify-center" data-id="element-148">
                    <Icon className="w-6 h-6 text-red-500" data-id="element-149" />
                  </div>
                  <div data-id="element-150">
                    <h3 className="font-heading text-2xl text-text-primary mb-3" data-id="element-151">
                      {problem.title}
                    </h3>
                    <p className="text-text-secondary font-body leading-relaxed" data-id="element-152">
                      {problem.description}
                    </p>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="bg-gradient-to-r from-red-900/20 to-bg-tertiary border border-red-900/30 rounded-sm p-8 sm:p-12" data-id="element-153">
          <div className="max-w-3xl" data-id="element-154">
            <h3 className="font-heading text-3xl sm:text-4xl text-text-primary mb-4" data-id="element-155">
              La Verdad Incómoda
            </h3>
            <p className="text-lg text-text-secondary font-body leading-relaxed mb-6" data-id="element-156">
              Cada año que pasás frente a la pantalla sin levantar peso, tus
              músculos se encogen y tus huesos se vuelven porosos. Se llama{' '}
              <span className="text-red-400 font-semibold" data-id="element-157">Sarcopenia</span>, y
              es el enemigo silencioso que te roba la autonomía mientras creés
              que estás "bien".
            </p>
            <p className="text-lg text-text-secondary font-body leading-relaxed" data-id="element-158">
              No es tu edad. Es tu falta de carga. Y tiene solución.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}